
export const isIe = {
  versions: (function () {
    return {
      trident: navigator.userAgent.indexOf('Trident') > -1
    }
  }()),
  language: (navigator.browserLanguage || navigator.language).toLowerCase()
}

export const isEdge = {
  versions: (function () {
    return {
      Edge: navigator.userAgent.indexOf('Edge') > -1
    }
  }()),
  language: (navigator.browserLanguage || navigator.language).toLowerCase()
}

export function isFullscreen () {
  return document.fullscreenElement || document.mozFullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement
}

export function supportsFullscreen () {
  return document.fullscreenEnabled || document.mozFullscreenEnabled || document.mozFullScreenEnabled || document.webkitFullscreenEnabled || document.msFullscreenEnabled
}

export function isPointerLocked () {
  return document.pointerLockElement || document.mozPointerLockElement || document.webkitPointerLockElement
}

export function requestFullscreen (a, b) {
  a.requestFullscreen
    ? a.requestFullscreen()
    : a.mozRequestFullScreen
      ? a.mozRequestFullScreen()
      : a.webkitRequestFullscreen
        ? a.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT)
        : a.msRequestFullscreen && a.msRequestFullscreen()
  if (b) {
    document.addEventListener('fullscreenchange webkitfullscreenchange mozfullscreenchange MSFullscreenChange', this.requestPointerLock.bind(this))
  }
}

export function requestPointerLock () {
  let a
  if (document.fullscreenElement) a = document.fullscreenElement()
  else if (document.mozFullscreenElement) a = document.mozFullscreenElement()
  else if (document.mozFullScreenElement) a = document.mozFullScreenElement()
  else {
    if (!document.webkitFullscreenElement) return
    a = document.webkitFullscreenElement()
  }
  a.requestPointerLock = a.requestPointerLock || a.mozRequestPointerLock || a.webkitRequestPointerLock
  a.requestPointerLock()
  document.removeEventListener('fullscreenchange webkitfullscreenchange mozfullscreenchange MSFullscreenChange', this.requestPointerLock.bind(this))
}

export function exitPointerLock () {
  document.exitPointerLock = document.exitPointerLock || document.mozExitPointerLock || document.webkitExitPointerLock
  document.exitPointerLock()
}

export function exitFullscreen () {
  document.exitFullscreen ? document.exitFullscreen() : document.msExitFullscreen ? document.msExitFullscreen() : document.mozCancelFullScreen ? document.mozCancelFullScreen() : document.webkitExitFullscreen && document.webkitExitFullscreen()
}

export function details () {
  var a = navigator.userAgent.match('(Firefox|Chrome|Safari)/([\\d]+)')
  return a ? {
    name: a[1],
    version: parseInt(a[2]),
    platform: navigator.platform
  } : {}
}

export function is (a) {
  return this.details() && this.details().name === a
}

export function inIframe () {
  return window.parent !== window
}

export function aspectRatio () {
  var a = window.innerWidth / window.innerHeight
  return isFinite(a) ? a : 0
}

export function userAgent () {
  return window.navigator.userAgent
}

export function isMobile () {
  var a = navigator.userAgent || navigator.vendor || window.opera
  return /(android|bb\d+|meego).+mobile|android|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od|ad)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))
}

export function isWeixin () {
  return navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger'
}

export function isSmallScreen () {
  return window.screen.width / window.devicePixelRatio < 240
}

export function detectIE () {
  return window.navigator.userAgent.indexOf('MSIE ') !== -1 || !!navigator.userAgent.match(/Trident.*rv\:11\./)
}

export function detectSafari () {
  return window.navigator.userAgent.indexOf('Safari') !== -1 && !this.detectChrome()
}

export function detectFirefox () {
  return window.navigator.userAgent.indexOf('Firefox') !== -1
}

export function detectChrome () {
  return window.navigator.userAgent.indexOf('Chrome') !== -1 && !this.detectOpera()
}

export function detectOpera () {
  return window.navigator.userAgent.indexOf('OPR') !== -1
}

export function detectIOS () {
  return /iPad|iPhone|iPod/.test(window.navigator.userAgent)
}

export function detectAndroid () {
  return window.navigator.userAgent.indexOf('Android') !== -1
}

export function detectAndroidMobile () {
  var a = window.navigator.userAgent
  return this.detectAndroid() && a.indexOf('Mobile') !== -1
}

export function detectSamsungNative () {
  var a = window.navigator.userAgent
  return a.indexOf('SM-G900H') !== -1 || a.indexOf('GT-I9500') !== -1 || a.indexOf('SM-N900') !== -1
}

export function detectSamsungS6 () {
  return window.navigator.userAgent.indexOf('SM-G92') !== -1
}

export function detectHUAWEI5X () {
  return window.navigator.userAgent.indexOf('KIW-TL00H') !== -1
}

export function iosVersion () {
  if (!this.detectIOS()) throw new e('Did not detect an iDevice')
  return d(/((?:\d+\_?){1,3}) like Mac OS/, '_')
}

export function androidVersion () {
  if (!this.detectAndroid()) throw new e('Did not detect an Android based device')
  return d(/Android ((?:\d+\.?){1,3})/, '.')
}

export function valueFromCookie (a, b) {
  var c = new RegExp(a + '=([0-9a-f]+)(; ?|$)').exec(document.cookie)
  if (!c) return b
  var d = c[1]
  return typeof b === 'boolean' ? d === 'true' || d === '1' : typeof b === 'number' ? parseFloat(d) : d
}

export function valueFromHash (a, b) {
  var c = new RegExp('[#&?]' + a + '=([^#&?]*)')
  var d = c.exec(window.location.href)
  if (!d) return b
  var e = d[1]
  return typeof b === 'boolean' ? e === 'true' || e === '1' : typeof b === 'number' ? parseFloat(e) : window.decodeURIComponent(e)
}

export function getAllValueFromSearch () {
  var a = window.location.search
  var b = {}
  if (a.indexOf('?') !== -1) {
    for (var c = a.substr(1), d = c.split('&'), e = '', f = 0; f < d.length; f++) {
      e = d[f].split('=')
      b[e[0]] = unescape(e[1])
    }
  }
  return b
}

export function getQueryString (a) {
  var b = new RegExp('(^|&)' + a + '=([^&]*)(&|$)', 'i')
  var c = window.location.search.substr(1).match(b)
  return c != null ? decodeURI(c[2]) : null
}

export function getUuid () {
  function ramStr () {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
  }
  return (ramStr() + ramStr() + '-' + ramStr() + '-' + ramStr() + '-' + ramStr() + '-' + ramStr() + ramStr() + ramStr())
}
